<template lang="pug">
  KryptonCardFormSpawnPoint(:section="method")
</template>

<script>
import { mapGetters } from 'vuex'
import KryptonCardFormSpawnPoint from '@/host/components/controls/CardFormSpawnPoint'

export default {
  name: 'EmbeddedCardForm',
  components: {
    KryptonCardFormSpawnPoint
  },
  props: {
    method: { type: String, default: '' }
  },
  computed: {
    ...mapGetters(['isFormReady']),
    isLoaded() {
      return this.isFormReady(this.method)
    }
  },
  watch: {
    isLoaded(newVal) {
      if (newVal) {
        this.$emit('ready')
      }
    }
  }
}
</script>
